module.exports = __webpack_public_path__ + "static/media/2.17450301.png";